"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/es/object/assign");
require("core-js/es/object/entries");
require("core-js/es/array/from");
require("core-js/web/url-search-params");
require("core-js/es/promise");
require("custom-event-polyfill");
require("xcssmatrix");
var smoothscroll = require("smoothscroll-polyfill");
var ReactDOM = require("react-dom");
var WindowApi_1 = require("@/api/browser/WindowApi");
var root_1 = require("@/rendering/common/root");
var store_1 = require("@/rendering/common/store");
var getAllState_1 = require("@/utils/getAllState");
window.onunhandledrejection = function (data) {
    console.log(data.reason);
};
if (typeof window !== 'undefined') {
    smoothscroll.polyfill();
    var stateFromServer = window.REDUX_DATA;
    var defaultPage = WindowApi_1.getPageFromQueryParams();
    var rootView = void 0;
    var rootStore = void 0;
    var setAllStateSymbol = void 0;
    // dispatch whole state tree from server to client
    if (stateFromServer) {
        rootView = root_1.getRootView(stateFromServer.page);
        rootStore = store_1.getStore(stateFromServer.page, true);
        window.REDUX = rootStore;
        setAllStateSymbol = getAllState_1.getAllState(stateFromServer.page);
        rootStore.dispatch({ type: setAllStateSymbol, payload: stateFromServer });
    }
    else {
        rootView = root_1.getRootView(defaultPage);
        rootStore = store_1.getStore(defaultPage, true);
    }
    // client side rendering
    ReactDOM.render(rootView(rootStore), document.getElementById('app'));
}
